module.exports = __webpack_public_path__ + "static/gobierno-zapopan@2x-0cacd8a7b2c1d98d55a94c79f980fa07.png";